import cloneDeep from "lodash.clonedeep";
import set from "lodash.set";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { ACTIONS } from "../../constants";
import ajv from "../../helpers/ajv";
import { resolveSchema } from "../../helpers/resolveSchema";
import Button from "../components/Button";
import Form from "../components/Form";
import Modal from "../components/Modal";
import mapChildren from "../helpers/mapChildren";
import { useContractQuery } from "../hooks";

const DeclineContractForm = ({ handleClose, schemaData }) => {
  const [formValues, setFormValues] = useState({});
  const clonedSchema = cloneDeep(schemaData);
  const resolvedSchema = resolveSchema(clonedSchema, formValues);
  const clonedValues = cloneDeep(formValues);
  const validate = ajv.compile(schemaData);
  const isValid = validate(clonedValues);
  const { updateContract, isUpdating, productRef, contractId, endorsementId } = useContractQuery();

  const handleChange = (...args) => {
    const clonedFormValues = cloneDeep(formValues);

    if (args.length === 1) {
      const [event] = args;

      set(clonedFormValues, event.target.name, event.target.value);
    }

    if (args.length === 2) {
      const [value, name] = args;

      set(clonedFormValues, name, value);
    }

    setFormValues(clonedFormValues);
  };

  const handleSubmit = async () => {
    await updateContract({
      data: { type: ACTIONS.DECLINE_TO_QUOTE_CONTRACT, payload: formValues },
      contractId,
      productRef,
      endorsementId,
    });

    handleClose();
  };

  return (
    <div className="p-6">
      <Form onSubmit={handleSubmit}>
        {mapChildren({
          formValues,
          onChange: handleChange,
          parentKey: "",
          parentSchema: resolvedSchema,
          setFormValues,
          validationErrors: validate.errors,
        })}

        <div className="flex">
          <Button className="mr-4" isDisabled={!isValid || isUpdating} kind="primary" type="submit">
            Submit
          </Button>

          <Button onClick={handleClose}>Cancel</Button>
        </div>
      </Form>
    </div>
  );
};

const DeclineContractModal = ({ handleClose }) => {
  const { schemaData, isLoading } = useContractQuery();

  return (
    <Modal handleClose={handleClose} headingText="Decline to quote" isLoading={isLoading}>
      <DeclineContractForm handleClose={handleClose} schemaData={schemaData.properties.DeclinedForm} />
    </Modal>
  );
};

DeclineContractModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default DeclineContractModal;
